// src/firebase/config.ts
// SEC-006 FIX: Use environment variables instead of hardcoded values

export const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY || "AIzaSyBrsBXKw-9hKHGzvh7jNhoLXzkIIeYPQ3o",
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN || "trade-insights-journal-f0ddd.firebaseapp.com",
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || "trade-insights-journal-f0ddd",
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET || "trade-insights-journal-f0ddd.firebasestorage.app",
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID || "868449160822",
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID || "1:868449160822:web:f9c9698acc056aa7c75957",
};
